import { render } from "./OtherAccountGroupList.vue?vue&type=template&id=b5f19930&scoped=true"
import script from "./OtherAccountGroupList.vue?vue&type=script&lang=js"
export * from "./OtherAccountGroupList.vue?vue&type=script&lang=js"

import "./OtherAccountGroupList.vue?vue&type=style&index=0&id=b5f19930&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f19930"]])

export default __exports__